<template>

<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg4860"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs4864"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath4874"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path4872" /></clipPath></defs><g
     id="g4866"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g4868"><g
         id="g4870"
         clip-path="url(#clipPath4874)"><g
           id="g4876"
           transform="translate(13.5498,364.5)"><path
             d="m 0,0 c 0,16.151 13.098,29.249 29.249,29.249 h 41.509 c 22.087,0 39.992,17.905 39.992,39.991 v 41.51 c 0,16.15 13.097,29.248 29.248,29.248"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4878" /></g><g
           id="g4880"
           transform="translate(407.4316,105.21)"><path
             d="m 0,0 v 359.299 c 0,22.08 -17.91,39.991 -40,39.991 h -222.42 c -13.26,0 -25.98,-5.27 -35.351,-14.641 L -379.24,303.18 c -9.37,-9.37 -14.64,-22.09 -14.64,-35.35 V -12.44 c 0,-22.08 17.91,-39.99 40,-39.99 h 299.949"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4882" /></g><g
           id="g4884"
           transform="translate(78.7354,307.2002)"><path
             d="M 0,0 V 50.638 L 34.235,1.062 C 34.87,0.145 35.55,0.594 35.55,1.709 l -0.474,49.023"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4886" /></g><g
           id="g4888"
           transform="translate(260.3369,357.9326)"><path
             d="M 0,0 V -50.732"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4890" /></g><g
           id="g4892"
           transform="translate(51.3408,357.9326)"><path
             d="M 0,0 V -50.732"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4894" /></g><g
           id="g4896"
           transform="translate(369.6367,357.4697)"><path
             d="M 0,0 H -21.182 V -50.27 H 0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4898" /></g><g
           id="g4900"
           transform="translate(368.0742,332.335)"><path
             d="M 0,0 H -19.619"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4902" /></g><g
           id="g4904"
           transform="translate(321.792,353.6006)"><path
             d="m 0,0 c -4.049,2.735 -8.93,4.332 -14.183,4.332 -14.009,0 -25.366,-11.356 -25.366,-25.366 0,-14.009 11.357,-25.366 25.366,-25.366 5.69,0 10.37,1.873 13.922,5.036 0.735,0.655 1.421,1.364 2.059,2.125"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4906" /></g><g
           id="g4908"
           transform="translate(135.1074,357.9326)"><path
             d="m 0,0 17.346,-49.971 c 0.363,-1.023 1.813,-1.013 2.163,0.015 l 16.564,49.863"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4910" /></g><g
           id="g4912"
           transform="translate(236.3066,332.5664)"><path
             d="m 0,0 c 0,-14.009 -11.357,-25.366 -25.367,-25.366 -14.009,0 -25.366,11.357 -25.366,25.366 0,14.01 11.357,25.366 25.366,25.366 C -11.357,25.366 0,14.01 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4914" /></g><g
           id="g4916"
           transform="translate(384.21,272.6099)"><path
             d="M 0,0 H -268.91"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4918" /></g><g
           id="g4920"
           transform="translate(85.3398,272.6099)"><path
             d="M 0,0 H -48.57"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4922" /></g><g
           id="g4924"
           transform="translate(91.2461,231.1089)"><path
             d="M 0,0 H 158.99"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4926" /></g><g
           id="g4928"
           transform="translate(308.0752,231.1089)"><path
             d="M 0,0 H 21.655"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4930" /></g><g
           id="g4932"
           transform="translate(91.2461,192.3271)"><path
             d="M 0,0 H 158.99"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4934" /></g><g
           id="g4936"
           transform="translate(308.0752,192.3271)"><path
             d="M 0,0 H 21.655"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4938" /></g><g
           id="g4940"
           transform="translate(91.2461,153.5449)"><path
             d="M 0,0 H 158.99"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4942" /></g><g
           id="g4944"
           transform="translate(308.0752,153.5449)"><path
             d="M 0,0 H 21.655"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4946" /></g><g
           id="g4948"
           transform="translate(91.2461,114.7632)"><path
             d="M 0,0 H 158.99"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4950" /></g><g
           id="g4952"
           transform="translate(326.9209,114.7598)"><path
             d="M 0,0 H -18.85"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4954" /></g><g
           id="g4956"
           transform="translate(471.3799,97.54)"><path
             d="m 0,0 23.22,41.11 c 8.08,14.3 3.03,32.44 -11.27,40.51 -14.29,8.07 -32.429,3.03 -40.5,-11.27 L -72.1,-6.76 -94.42,22.03 c -10.059,12.97 -28.729,15.34 -41.71,5.28 -12.98,-10.06 -15.34,-28.74 -5.28,-41.71 l 49.71,-64.13 c 5.66,-7.29 14.35,-11.51 23.49,-11.51 0.72,0 1.44,0.03 2.17,0.08 9.92,0.72 18.83,6.36 23.73,15.03 l 27.65,48.96"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4958" /></g><g
           id="g4960"
           transform="translate(344.1582,458.3423)"><path
             d="m 0,0 c -1.062,0.884 -7.149,5.474 -16.078,2.784 -9.047,-2.725 -11.294,-15.103 -5.146,-19.926 3.53,-2.768 8.841,-5.045 16,-7.575 16.022,-5.663 10.099,-28.258 -6.199,-28.367 -6.359,-0.042 -9.333,0.362 -14.92,4.017"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4962" /></g><g
           id="g4964"
           transform="translate(332.7383,397.0103)"><path
             d="M 0,0 V 8.251"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4966" /></g><g
           id="g4968"
           transform="translate(332.7383,461.9463)"><path
             d="M 0,0 V 7.638"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4970" /></g></g></g></g></svg>
</template>
